class IdleTimer {
  constructor({ timeout = 7200, warningTimeout = 10, onTimeout, onWarning, onReset }) {
    this.timeout = timeout * 1000;
    this.warningTimeout = warningTimeout * 1000;
    this.onTimeout = onTimeout;
    this.onWarning = () => {
      this.removeListeners();
      onWarning();
    };
    this.onReset = onReset;
    this.warningFired = false;

    this.eventHandler = this.updateExpiredTime.bind(this);
    this.tracker();
    this.startInterval();
  }
  
  startInterval() {
    this.updateExpiredTime();

    this.interval = setInterval(() => {
      const expiredTime = parseInt(localStorage.getItem("_expiredTime") || 0, 10);
      if (!expiredTime) return this.updateExpiredTime();
      if (expiredTime < Date.now()) {
        if (this.onTimeout) {
          this.onTimeout(expiredTime);
          this.cleanUp();
        }
      }
      if (expiredTime - this.warningTimeout < Date.now() && !this.warningFired) {
        if (this.onWarning) {
          this.onWarning();
          this.warningFired = true;
        }
      }
      if (expiredTime - this.warningTimeout > Date.now() && this.warningFired) {
        this.onReset();
        this.warningFired = false;
      }
    }, 1000);
  }

  updateExpiredTime() {
    localStorage.setItem("_expiredTime", Date.now() + this.timeout);
  }

  tracker() {
    window.addEventListener("mousemove", this.eventHandler);
    window.addEventListener("scroll", this.eventHandler);
    window.addEventListener("keydown", this.eventHandler);
  }

  removeListeners () {
    window.removeEventListener("mousemove", this.eventHandler);
    window.removeEventListener("scroll", this.eventHandler);
    window.removeEventListener("keydown", this.eventHandler);
  }

  cleanUp() {
    clearInterval(this.interval);
    this.removeListeners();
  }
}

export default IdleTimer;
